import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * 共通ドラッグプレビューカード (presentational only)。
 * 各 useDragLayer ラッパー (FreeProductDragPreview / SupplyTableRowDragPreview など)
 * が data を整形してこのカードに渡すことで、レイアウト・フォントを完全に揃える。
 */
const DragPreviewCard = ({ currentOffset, productName, specs, extra }) => {
  if (!currentOffset) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        pointerEvents: "none",
        zIndex: 2000,
        transform: `translate(${currentOffset.x + 12}px, ${currentOffset.y + 12}px)`,
        bgcolor: "#fff",
        border: "2px solid",
        borderColor: "primary.main",
        borderRadius: 2,
        boxShadow: 4,
        px: 2,
        py: 1,
        opacity: 0.95,
        minWidth: 280,
        maxWidth: 420,
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
        {productName || "(品名なし)"}
      </Typography>
      {specs && (
        <Typography sx={{ fontSize: 15, color: "text.secondary", mt: 0.25 }}>
          {specs}
        </Typography>
      )}
      {extra && (
        <Typography sx={{ fontSize: 15, mt: 0.25 }}>{extra}</Typography>
      )}
    </Box>
  );
};

export default DragPreviewCard;
